'use client';
import { useState, useEffect } from 'react';

export interface CompanyInfo {
  name: string;
  address: string;
  vatNumber: string;
  companyName?: string;
}

const STORAGE_KEY = 'glanz_company_info';

const DEFAULT_COMPANY: CompanyInfo = {
  name: 'Diamond Merchant Co., Ltd.',
  address: '123 Jewelry District, Bangkok 10500',
  vatNumber: 'TH-0105563012345',
};

export function getCompanyInfo(): CompanyInfo {
  if (typeof window === 'undefined') return DEFAULT_COMPANY;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return { ...DEFAULT_COMPANY, ...JSON.parse(stored) };
  } catch {
    // corrupt/unavailable storage — fall through to defaults
  }
  return DEFAULT_COMPANY;
}

export function saveCompanyInfo(info: Partial<CompanyInfo>): void {
  if (typeof window === 'undefined') return;
  try {
    const current = getCompanyInfo();
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...current, ...info }));
  } catch {
    // storage unavailable — ignore
  }
}

export function useCompanyInfo(): CompanyInfo {
  const [info, setInfo] = useState<CompanyInfo>(DEFAULT_COMPANY);

  useEffect(() => {
    setInfo(getCompanyInfo());

    const handleStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) {
        setInfo(getCompanyInfo());
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return info;
}
